import { createSelector } from 'reselect';
import {
  getTrackAssetsSelector,
  videosByIdSelector,
} from 'redux/modules/embed/selectors';

// selects a sorted list of all of the autoframed media assets for the given track
const autoframedMediaTrackAssetsSelector = createSelector(
  [
    (state, trackId: string) => getTrackAssetsSelector(trackId)(state),
    videosByIdSelector,
  ],
  (trackAssets, videosById) => {
    const autoframedAssetIds = trackAssets.reduce((acc, asset) => {
      if (asset.type === 'autoframed-video') {
        acc.push(asset.id);
      }
      return acc;
    }, [] as string[]);

    return autoframedAssetIds
      .map(id => {
        const video = videosById.get(id);

        return {
          id,
          startMillis: video?.startMillis,
          endMillis: video?.endMillis,
        };
      })
      .sort((a, b) => a.startMillis - b.startMillis);
  },
);

// given a track and playback time, selects the autoframed video under the playhead,
// or undefined if the track has no autoframed media in that position
export const autoframedVideoIdAtPositionSelector = createSelector(
  [
    (_state, _trackId, positionMillis: number) => positionMillis,
    autoframedMediaTrackAssetsSelector,
  ],
  (positionMillis, trackAssets) => {
    const asset = trackAssets.find(
      a => a.startMillis <= positionMillis && a.endMillis >= positionMillis,
    );

    return asset?.id;
  },
);
